const Pace = () => (
  <svg width="20" height="23" xmlns="http://www.w3.org/2000/svg">
    <g fill="#2A3135" fillRule="nonzero" stroke="#2A3135" strokeWidth=".3">
      <path d="M7.545 2.636h4.91a.818.818 0 100-1.636h-4.91a.818.818 0 100 1.636zM12.314 9.474l-2.892 2.893a.818.818 0 101.157 1.157l2.892-2.893a.818.818 0 10-1.157-1.157z" />
      <path d="M10 3.945c-4.974 0-9 4.026-9 9s4.025 9 9 9c4.974 0 9-4.025 9-9 0-4.974-4.025-9-9-9zm0 16.364c-4.06 0-7.364-3.303-7.364-7.364 0-4.06 3.304-7.363 7.364-7.363 4.06 0 7.364 3.303 7.364 7.363 0 4.06-3.304 7.364-7.364 7.364z" />
    </g>
  </svg>
);

export default Pace;
